<div class="sm:px-6 pt-16 pb-8 xl:px-8">
  <!-- Indicador de Save -->
  <div *ngIf="showSaveIndicator" class="fixed top-4 right-4 z-50 bg-white border border-gray-300 rounded-lg shadow-lg p-3 flex items-center space-x-2">
    <app-loading-spinner *ngIf="saveIndicatorText.includes('Salvando')" size="xs"></app-loading-spinner>
    <div *ngIf="saveIndicatorText.includes('sucesso')" class="text-green-600">
      <i class="fas fa-check-circle"></i>
    </div>
    <div *ngIf="saveIndicatorText.includes('Erro')" class="text-red-600">
      <i class="fas fa-exclamation-circle"></i>
    </div>
    <span class="text-sm font-medium" [ngClass]="{
      'text-blue-600': saveIndicatorText.includes('Salvando'),
      'text-green-600': saveIndicatorText.includes('sucesso'),
      'text-red-600': saveIndicatorText.includes('Erro'),
      'text-gray-600': !saveIndicatorText.includes('Salvando') && !saveIndicatorText.includes('sucesso') && !saveIndicatorText.includes('Erro')
    }">
      {{ saveIndicatorText }}
    </span>
  </div>

  <div class="w-full px-5 py-3">
    <!-- Cabeçalho -->
    <div class="w-full flex flex-col md:flex-row md:justify-between mb-4 md:mb-8 md:items-center gap-4">
      <div>
        <div class="flex items-center mb-1">
          <a class="text-sm text-black cursor-pointer" (click)="goBack()">Planos de Tratamento</a>
          <span class="text-sm text-black mx-2">/</span>
          <a class="text-sm text-black">Detalhes do Plano</a>
        </div>
        <div class="flex items-center gap-3">
          <h1 class="font-bold text-xl md:text-2xl">Plano de Tratamento</h1>
          <!-- NOVO: Indicador de fotos sendo enviadas no título -->
          <div *ngIf="hasAnyProductPhotoUploading()" class="flex items-center bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm font-medium">
            <app-loading-spinner size="xs" class="mr-2"></app-loading-spinner>
            Enviando fotos
          </div>
        </div>
      </div>

      <div class="flex flex-wrap md:flex-nowrap gap-2 md:gap-4">
        <!-- Botão de encerrar no cabeçalho -->
        <div class="relative">
          <button #closeButton *ngIf="treatmentPlan && treatmentPlan.status === 'ACTIVE'" (click)="closeTreatmentPlan()"
            class="bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2 px-3 md:px-4 rounded-md flex items-center text-sm md:text-base cursor-pointer">
            <span>Encerrar</span>
          </button>
        </div>

        <button *ngIf="treatmentPlan && treatmentPlan.status !== 'ACTIVE'"
          (click)="downloadPdf()"
          [disabled]="loading || downloadingPdf"
          class="bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-3 md:px-4 rounded-md flex items-center text-sm md:text-base">
          <span *ngIf="!downloadingPdf">Baixar PDF</span>
          <span *ngIf="downloadingPdf" class="flex items-center">
            Gerando PDF...
          </span>
        </button>

        <!-- Botão para reenviar PDF por email (apenas para planos encerrados) -->
        <button *ngIf="treatmentPlan && treatmentPlan.status === 'CLOSED'" 
          (click)="sendPdfByEmail()"
          [disabled]="sendingEmail || loading"
          [ngClass]="{
            'bg-green-500 hover:bg-green-600': !sendingEmail,
            'bg-green-300 cursor-not-allowed': sendingEmail
          }"
          class="bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-3 md:px-4 rounded-md flex items-center text-sm md:text-base">
          <span *ngIf="!sendingEmail">Reenviar por Email</span>
          <span *ngIf="sendingEmail" class="flex items-center">
            <app-loading-spinner size="xs" class="mr-2"></app-loading-spinner>
            Enviando...
          </span>
        </button>

        <button *ngIf="treatmentPlan && treatmentPlan.status === 'ACTIVE'" (click)="forceSave('manual_save')"
          [disabled]="showSavingIndicator || loading "
          class="bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2 px-3 md:px-4 rounded-md flex items-center text-sm md:text-base">
          <span>{{ (showSavingIndicator) ? 'Salvando...' : 'Salvar' }}</span>
        </button>

        <button (click)="goBack()"
          [disabled]="hasAnyProductPhotoUploading()"
          [ngClass]="{
            'bg-gray-200 hover:bg-gray-300 text-black': !hasAnyProductPhotoUploading(),
            'bg-gray-100 text-gray-400 cursor-not-allowed': hasAnyProductPhotoUploading()
          }"
          class="font-medium py-2 px-3 md:px-4 rounded-md flex justify-center items-center text-sm md:text-base">
          <span *ngIf="!hasAnyProductPhotoUploading()">Voltar</span>
          <span *ngIf="hasAnyProductPhotoUploading()" class="flex items-center">
            <app-loading-spinner size="xs" class="mr-2"></app-loading-spinner>
            Fotos sendo enviadas...
          </span>
        </button>
      </div>
    </div>

    <div [hidden]="!loading">
      <app-loading></app-loading>
    </div>

    <!-- Saving overlay -->
    <div *ngIf="showSavingIndicator" class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div class="bg-white p-6 rounded-lg shadow-lg flex flex-col items-center">
        <app-loading-spinner size="lg" class="mb-4"></app-loading-spinner>
        <p class="text-lg font-medium">Salvando plano de tratamento...</p>
      </div>
    </div>

    <!-- Conteúdo principal -->
    <div *ngIf="!loading && treatmentPlan">
      <!-- Mensagem de sucesso/erro -->
      <div *ngIf="showMessage"
        class="fixed top-5 right-5 p-4 rounded-lg shadow-2xl z-[9999] max-w-md transition-all duration-300" [ngClass]="{
          'bg-green-50 border-2 border-green-500 text-green-800': messageType === 'success',
          'bg-red-50 border-2 border-red-500 text-red-800': messageType === 'error'
        }"
        style="background-color: rgba(255, 255, 255, 1) !important;">
        <div class="flex items-start">
          <div class="flex-shrink-0">
            <i *ngIf="messageType === 'success'" class="fas fa-check-circle text-green-500 text-lg"></i>
            <i *ngIf="messageType === 'error'" class="fas fa-exclamation-circle text-red-500 text-lg"></i>
          </div>
          <div class="ml-3 flex-1">
            <p class="text-sm font-semibold">{{ messageText }}</p>
          </div>
          <div class="ml-auto pl-3">
            <div class="-mx-1.5 -my-1.5">
              <button (click)="closeMessage()" class="inline-flex rounded-full p-1.5 hover:bg-gray-100 transition-colors" [ngClass]="{
                  'text-green-600 hover:text-green-800': messageType === 'success',
                  'text-red-600 hover:text-red-800': messageType === 'error'
                }">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Mensagem informativa sobre campos obrigatórios - exibida somente quando o botão de ajuda é clicado -->
      <div *ngIf="treatmentPlan.status === 'ACTIVE'"
        class="overflow-hidden transition-all duration-[450ms] ease-in-out"
        [style.max-height]="showHelpInfoVisible ? '500px' : '0'"
        [style.margin-bottom]="showHelpInfoVisible ? '1.5rem' : '0'">
        <div class="bg-blue-50 border-l-4 border-blue-500 p-4 rounded-md shadow-sm relative">
          <button (click)="showHelpInfoVisible = false" class="absolute top-2 right-2 text-blue-500 hover:text-blue-700">
            <i class="fas fa-times"></i>
          </button>
          <div class="flex">
            <div class="flex-shrink-0">
              <i class="fas fa-info-circle text-blue-500"></i>
            </div>
            <div class="ml-3">
              <p class="text-sm text-blue-700">
                <span class="font-medium">Sistema de salvamento flexível:</span>
                Você pode salvar o plano de tratamento a qualquer momento, mesmo com campos obrigatórios em branco.
              </p>
              <p class="text-sm text-blue-700 mt-2">
                <span class="font-medium">Campos obrigatórios para encerramento:</span>
              </p>
              <ul class="list-disc ml-5 mt-1 text-sm text-blue-700">
                <li><strong>Informações Gerais:</strong> Idade do paciente</li>
                <li><strong>Produtos (opcional):</strong> Se houver produtos, é necessário preencher dados básicos (fabricante, produto, datas), regiões de aplicação e pelo menos uma foto por produto</li>
              </ul>
              <p class="text-sm text-blue-700 mt-2">
                <span class="font-medium">Nota:</span> O plano só pode ser encerrado quando todos os campos obrigatórios estiverem preenchidos.
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Abas -->
      <div class="flex flex-col md:flex-row md:justify-between border-b border-gray-200 mb-6">
        <nav class="flex overflow-x-auto -mb-px hide-scrollbar">
          <button (click)="changeTab('info')"
            class="py-3 md:py-4 px-4 md:px-6 font-medium text-sm border-b-2 focus:outline-none whitespace-nowrap"
            [ngClass]="{'border-indigo-600 text-indigo-600': activeTab === 'info', 'border-transparent text-gray-500 hover:text-gray-700': activeTab !== 'info'}">
            Informações Gerais
          </button>
          <button (click)="changeTab('products')"
            class="py-3 md:py-4 px-4 md:px-6 font-medium text-sm border-b-2 focus:outline-none whitespace-nowrap"
            [ngClass]="{'border-indigo-600 text-indigo-600': activeTab === 'products', 'border-transparent text-gray-500 hover:text-gray-700': activeTab !== 'products'}">
            Produtos
          </button>
          <button (click)="changeTab('photos')"
            class="py-3 md:py-4 px-4 md:px-6 font-medium text-sm border-b-2 focus:outline-none whitespace-nowrap"
            [ngClass]="{'border-indigo-600 text-indigo-600': activeTab === 'photos', 'border-transparent text-gray-500 hover:text-gray-700': activeTab !== 'photos'}">
            Fotos
          </button>
        </nav>

        <div class="flex flex-wrap items-center gap-2 md:gap-4 mb-4 mt-2 md:mt-0">
          <div
            *ngIf="treatmentPlan.status === 'ACTIVE'"
            class="px-2 py-1 md:px-3 md:py-2 inline-block rounded-full text-xs md:text-sm truncate"
            [ngClass]="{
              'bg-gray-100 text-gray-800': !hasUnsavedChanges,
              'bg-red-50 text-red-700 border border-red-300': hasUnsavedChanges
            }">
            <a *ngIf="!hasUnsavedChanges">Salvo: {{ treatmentPlan.updated_at | date:'dd/MM/yyyy HH:mm:ss' }}</a>
            <a *ngIf="hasUnsavedChanges" class="flex items-center">
              <i class="fas fa-exclamation-circle mr-1"></i> Alterações não salvas
            </a>
          </div>
          <div
            *ngIf="treatmentPlan.status === 'CLOSED'"
            class="px-2 py-1 md:px-3 md:py-2 inline-block rounded-full text-xs md:text-sm bg-gray-100 text-gray-800">
            <a>Iniciou em: {{ treatmentPlan.created_at | date:'dd/MM/yyyy HH:mm:ss' }}</a>
          </div>
          <div
            *ngIf="treatmentPlan.status === 'CLOSED'"
            class="px-2 py-1 md:px-3 md:py-2 inline-block rounded-full text-xs md:text-sm bg-gray-100 text-gray-800">
            <a>Encerrou em: {{ treatmentPlan.published_at | date:'dd/MM/yyyy HH:mm:ss' }}</a>
          </div>
          <div class="px-2 py-1 md:px-3 md:py-2 inline-block rounded-full text-xs md:text-sm" [ngClass]="{
                    'bg-blue-100 text-blue-800': treatmentPlan.status === 'ACTIVE',
                    'bg-green-100 text-green-800': treatmentPlan.status === 'CLOSED'
                  }">
            {{ treatmentPlan.status === 'ACTIVE' ? 'Em Aberto' : 'Encerrado' }}
          </div>
          <button *ngIf="treatmentPlan && treatmentPlan.status === 'ACTIVE'"
            (click)="showHelpInfoVisible = !showHelpInfoVisible"
            class="bg-indigo-600 hover:bg-indigo-700 text-white font-medium px-3 py-1 rounded-full flex items-center text-sm md:text-base">
            <fa-icon [icon]="faQuestion"></fa-icon>
          </button>
        </div>
      </div>

      <!-- Aba de Informações Gerais -->
      <div *ngIf="activeTab === 'info'" class="bg-white rounded-lg shadow-md p-4 md:p-6">
        <form [formGroup]="treatmentPlanForm">
          <div class="grid grid-cols-1 xl:grid-cols-2 gap-6 mb-6">
            <div>
              <h2 class="text-lg font-semibold mb-3 md:mb-4">Dados do Paciente</h2>

              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-1">Nome do Paciente</label>
                <div class="flex items-center gap-2">
                  <input type="text" formControlName="patient_name"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100" readonly>
                  <span *ngIf="isModelPatient" class="shrink-0 inline-block px-2 py-0.5 text-xs font-semibold rounded bg-yellow-100 text-yellow-800">
                    Paciente modelo
                  </span>
                </div>
              </div>

              <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                <div>
                  <label for="patient-age-field" class="block text-sm font-medium text-gray-700 mb-1">Idade*</label>
                  <input id="patient-age-field" type="number" inputmode="numeric" formControlName="patient_age" (blur)="onFieldBlur('patient_age')"
                    class="w-full px-3 py-2 border rounded-md"
                                [ngClass]="{'border-gray-300': treatmentPlanForm.get('patient_age')?.valid || !treatmentPlanForm.get('patient_age')?.touched,
                       'border-red-500': treatmentPlanForm.get('patient_age')?.invalid && treatmentPlanForm.get('patient_age')?.touched}"
                    [disabled]="treatmentPlan.status === 'CLOSED'" placeholder="Informe a idade" min="0" max="120">
                                      <div
                      *ngIf="treatmentPlanForm?.get('patient_age')?.invalid && treatmentPlanForm?.get('patient_age')?.touched"
                    class="text-red-500 text-xs mt-1">
                    Este campo é obrigatório
                  </div>
                </div>

                <div class="mb-4">
                  <label class="block text-sm font-medium text-gray-700 mb-1">Uso de Imagem</label>
                  <div class="flex items-center border border-gray-300 rounded-md bg-gray-100">
                    <div class="flex items-center">
                      <span class="px-3 py-2 bg-gray-100 rounded-md text-sm">
                        {{ treatmentPlan.image_authorization ? 'Autoriza' : 'Não autoriza' }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h2 class="text-lg font-semibold mb-3 md:mb-4">Dados do Tratamento</h2>

              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-1">Procedimentos Contratados</label>
                <div class="bg-gray-100 border border-gray-300 rounded-md p-3 min-h-[80px] overflow-auto">
                  <p class="text-sm">{{ treatmentPlan.contracted_procedures }}</p>
                </div>
              </div>

              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-1">Profissional Responsável</label>
                <div class="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100 overflow-auto">
                  {{ treatmentPlan.responsible_professional }}
                </div>
              </div>

              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-1">Valor Total</label>
                <input type="text" [value]="formatCurrency(treatmentPlan.total_value)"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100" readonly>
              </div>
            </div>
          </div>

          <div class="flex flex-col gap-4 mb-6">
            <h2 class="text-lg font-semibold">Observações</h2>
            <!-- obs text -->
            <p class="text-xs text-justify">Obs.: Área destinada a observações gerais sobre o plano de aplicação. Utilize este espaço para anotar orientações específicas, recomendações de técnica, detalhes sobre profundidade, volume e pontos de injeção, além de quaisquer considerações pertinentes à segurança e ao resultado estético. Registre aqui notas adicionais que auxiliem no acompanhamento e na revisão do plano de aplicação.</p>
            <!-- Quando o status é ACTIVE, mostra o textarea para edição -->
            <textarea *ngIf="treatmentPlan.status !== 'CLOSED'" formControlName="observations" rows="4" (blur)="onFieldBlur('observations')"
              class="w-full px-3 py-2 border border-gray-300 rounded-md"
              placeholder="Adicione observações sobre o tratamento..." maxlength="10000"></textarea>
            <!-- Quando o status é CLOSED, mostra o div semelhante ao PDF -->
            <div *ngIf="treatmentPlan.status === 'CLOSED'" class="border p-2 bg-gray-50 min-h-[60px] whitespace-pre-wrap break-words">{{
              treatmentPlanForm.get('observations')?.value || '' }}</div>
            <div *ngIf="treatmentPlan.status !== 'CLOSED'" class="flex justify-end mt-1">
              <span class="text-sm text-gray-500">
                {{ treatmentPlanForm.get('observations')?.value?.length || 0 }}/10000 caracteres
              </span>
            </div>
          </div>
        </form>
      </div>

      <!-- Aba de Produtos -->
      <div *ngIf="activeTab === 'products'" class="bg-white rounded-lg shadow-md p-4 md:p-6">
        <!-- Lista de Produtos -->
        <div class="space-y-6 md:space-y-8" [formGroup]="treatmentPlanForm">
          <!-- Produtos existentes e novos -->
          <div *ngFor="let productControl of productsArray.controls; let i = index"
            class="bg-gray-50 border border-gray-200 rounded-lg p-4 md:p-6 mb-4 md:mb-6 relative"
            [formGroup]="getProductFormGroup(i)">
            <!-- Cabeçalho do produto -->
            <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4">
              <h2 class="text-lg md:text-xl font-semibold mb-2 sm:mb-0">Produto {{ i+1 }}</h2>

              <button *ngIf="treatmentPlan.status === 'ACTIVE'"
                (click)="removeProductControl(i)" class="text-red-600 hover:text-red-800 flex items-center">
                <span class="bg-red-100 hover:bg-red-200 rounded-full w-6 h-6 flex items-center justify-center mr-1">
                  <span class="font-bold">x</span>
                </span>
                <span>Excluir</span>
              </button>
            </div>

            <!-- Formulário do produto -->
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
              <div>
                <label for="product-{{i}}-application_date-main" class="block text-sm font-medium text-gray-700 mb-1">Data da Aplicação*:</label>
                <div class="relative">
                  <input id="product-{{i}}-application_date-main" type="text" formControlName="application_date"
                    mask="00/00/0000" [dropSpecialCharacters]="false" inputmode="numeric" autocomplete="off"
                    placeholder="DD/MM/AAAA"
                    [disabled]="treatmentPlan.status === 'CLOSED'" class="w-full px-3 py-2 border rounded-md"
                    [ngClass]="{'border-gray-300': getProductFormGroup(i).get('application_date')?.valid || !getProductFormGroup(i).get('application_date')?.touched, 
                                 'border-red-500': getProductFormGroup(i).get('application_date')?.invalid && getProductFormGroup(i).get('application_date')?.touched}">
                  <div class="absolute inset-y-0 right-0 flex items-center pr-3">
                    <i class="far fa-calendar-alt text-gray-400"></i>
                  </div>
                </div>
                <div
                  *ngIf="getProductFormGroup(i).get('application_date')?.invalid && getProductFormGroup(i).get('application_date')?.touched"
                  class="text-red-500 text-xs mt-1">
                  <ng-container *ngIf="getProductFormGroup(i).get('application_date')?.errors?.['required']; else appDateInvalidMsg">
                    Este campo é obrigatório
                  </ng-container>
                  <ng-template #appDateInvalidMsg>
                    Data inválida.
                  </ng-template>
                </div>
              </div>

              <div>
                <label for="product-{{i}}-manufacturer-main" class="block text-sm font-medium text-gray-700 mb-1">Fabricante*:</label>
                <div class="relative group">
                  <span [id]="'dropdown-button-manufacturer-' + i"
                    class="flex justify-between gap-2 items-center py-1.5 px-2 w-full rounded-md border text-gray-900 shadow-sm cursor-pointer focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    [class.border-gray-300]="getProductFormGroup(i).get('manufacturer')?.valid || !getProductFormGroup(i).get('manufacturer')?.touched"
                    [class.border-red-500]="getProductFormGroup(i).get('manufacturer')?.invalid && getProductFormGroup(i).get('manufacturer')?.touched"
                    [class.cursor-not-allowed]="treatmentPlan.status === 'CLOSED'"
                    [class.bg-gray-100]="treatmentPlan.status === 'CLOSED'"
                    (click)="treatmentPlan.status !== 'CLOSED' ? openCloseManufacturerSelect(i) : null">
                    <div class="w-5/6 text-start">{{getSelectedManufacturerLabel(i)}}</div>
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd"
                        d="M6.293 9.293a1 1 0 011.414 0L10 11.586l2.293-2.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                        clip-rule="evenodd" />
                    </svg>
                  </span>
                  <div [id]="'dropdown-background-manufacturer-' + i"
                    class="hidden bg-neutral-600 bg-opacity-70 fixed inset-0 z-10"
                    (click)="openCloseManufacturerSelect(i)">
                  </div>
                  <div [id]="'dropdown-menu-manufacturer-' + i"
                    class="hidden z-20 absolute w-full max-h-80 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 p-1 space-y-1">
                    <input [id]="'search-input-manufacturer-' + i"
                      class="block w-full px-4 py-2 text-gray-800 border rounded-md border-gray-300 focus:outline-none"
                      type="text" placeholder="Procure fabricantes" autocomplete="off"
                      (keyup)="onManufacturerSearch($event, 'manufacturer-' + i)">
                    <div [id]="'options-list-manufacturer-' + i"
                      class="block w-full max-h-52 overflow-auto p-1 cursor-pointer space-y-1">
                      <div *ngFor="let manufacturer of manufacturersList"
                        class="manufacturer-option flex items-center space-x-2 px-2 hover:bg-indigo-600 hover:text-white rounded-md">
                        <a class="cursor-pointer w-full text-left py-2"
                          (click)="onManufacturerSelect(manufacturer, i)">
                          {{manufacturer}}
                        </a>
                      </div>
                      <div class="manufacturer-option flex items-center space-x-2 px-2 hover:bg-indigo-600 hover:text-white rounded-md">
                        <a class="cursor-pointer w-full text-left py-2"
                          (click)="onManufacturerSelect('Outro', i)">
                          Outro
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="getProductFormGroup(i).get('manufacturer')?.invalid && getProductFormGroup(i).get('manufacturer')?.touched"
                  class="text-red-500 text-xs mt-1">
                  Este campo é obrigatório
                </div>

                <!-- Campo de texto para especificar o fabricante quando "Outro" for selecionado -->
                <div *ngIf="getProductFormGroup(i).get('manufacturer')?.value === 'Outro'" class="mt-2">
                  <label for="product-{{i}}-custom-manufacturer-main" class="sr-only">Especificar Fabricante</label>
                  <input id="product-{{i}}-custom-manufacturer-main" formControlName="custom_manufacturer" type="text" (blur)="onFieldBlur('custom_manufacturer')"
                    placeholder="Especifique o fabricante*" class="w-full px-3 py-2 border rounded-md"
                    [disabled]="treatmentPlan.status === 'CLOSED'"
                    [ngClass]="{'border-gray-300': !getProductFormGroup(i).get('custom_manufacturer')?.invalid || !getProductFormGroup(i).get('custom_manufacturer')?.touched, 
                              'border-red-500': getProductFormGroup(i).get('custom_manufacturer')?.invalid && getProductFormGroup(i).get('custom_manufacturer')?.touched}">
                  <div
                    *ngIf="getProductFormGroup(i).get('custom_manufacturer')?.invalid && getProductFormGroup(i).get('custom_manufacturer')?.touched"
                    class="text-red-500 text-xs mt-1">
                    É necessário especificar o fabricante
                  </div>
                </div>
              </div>

              <div>
                <label for="product-{{i}}-product_name-main" class="block text-sm font-medium text-gray-700 mb-1">Produto*:</label>
                <div class="relative group">
                  <span [id]="'dropdown-button-product-' + i"
                    class="flex justify-between gap-2 items-center py-1.5 px-2 w-full rounded-md border shadow-sm sm:text-sm sm:leading-6"
                    [class.border-gray-300]="getProductFormGroup(i).get('product_name')?.valid || !getProductFormGroup(i).get('product_name')?.touched"
                    [class.border-red-500]="getProductFormGroup(i).get('product_name')?.invalid && getProductFormGroup(i).get('product_name')?.touched"
                    [class.cursor-pointer]="isProductSelectEnabled(i)"
                    [class.cursor-not-allowed]="!isProductSelectEnabled(i)"
                    [class.bg-gray-100]="!isProductSelectEnabled(i)"
                    [class.text-gray-900]="isProductSelectEnabled(i)"
                    [class.text-gray-500]="!isProductSelectEnabled(i)"
                    [class.focus:ring-2]="isProductSelectEnabled(i)"
                    [class.focus:ring-indigo-600]="isProductSelectEnabled(i)"
                    (click)="isProductSelectEnabled(i) ? openCloseProductSelect(i) : null">
                    <div class="w-5/6 text-start">
                      {{ isProductSelectEnabled(i) || treatmentPlan.status === 'CLOSED' ? getSelectedProductLabel(i) : 'Selecione um fabricante primeiro' }}
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="currentColor" aria-hidden="true"
                      [class.text-gray-400]="!isProductSelectEnabled(i)">
                      <path fill-rule="evenodd"
                        d="M6.293 9.293a1 1 0 011.414 0L10 11.586l2.293-2.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                        clip-rule="evenodd" />
                    </svg>
                  </span>
                  <div [id]="'dropdown-background-product-' + i"
                    class="hidden bg-neutral-600 bg-opacity-70 fixed inset-0 z-10"
                    (click)="openCloseProductSelect(i)">
                  </div>
                  <div [id]="'dropdown-menu-product-' + i"
                    class="hidden z-20 absolute w-full max-h-80 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 p-1 space-y-1">
                    <input [id]="'search-input-product-' + i"
                      class="block w-full px-4 py-2 text-gray-800 border rounded-md border-gray-300 focus:outline-none"
                      type="text" placeholder="Procure produtos" autocomplete="off"
                      (keyup)="onProductSearch($event, 'product-' + i)">
                    <div [id]="'options-list-product-' + i"
                      class="block w-full max-h-52 overflow-auto p-1 cursor-pointer space-y-1">
                      <div *ngFor="let product of availableProducts[i] || []"
                        class="product-option flex items-center space-x-2 px-2 hover:bg-indigo-600 hover:text-white rounded-md">
                        <a class="cursor-pointer w-full text-left py-2"
                          (click)="onProductSelect(product, i)">
                          {{product}}
                        </a>
                      </div>
                      <div class="product-option flex items-center space-x-2 px-2 hover:bg-indigo-600 hover:text-white rounded-md">
                        <a class="cursor-pointer w-full text-left py-2"
                          (click)="onProductSelect('Outro', i)">
                          Outro
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="getProductFormGroup(i).get('product_name')?.invalid && getProductFormGroup(i).get('product_name')?.touched"
                  class="text-red-500 text-xs mt-1">
                  Este campo é obrigatório
                </div>

                <!-- Campo de texto para especificar o produto quando "Outro" for selecionado -->
                <div *ngIf="getProductFormGroup(i).get('product_name')?.value === 'Outro'" class="mt-2">
                  <label for="product-{{i}}-custom-product-name-main" class="sr-only">Especificar Produto</label>
                  <input id="product-{{i}}-custom-product-name-main" formControlName="custom_product_name" type="text" (blur)="onFieldBlur('custom_product_name')"
                    placeholder="Especifique o produto*" class="w-full px-3 py-2 border rounded-md"
                    [disabled]="treatmentPlan.status === 'CLOSED'"
                    [ngClass]="{'border-gray-300': !getProductFormGroup(i).get('custom_product_name')?.invalid || !getProductFormGroup(i).get('custom_product_name')?.touched, 
                              'border-red-500': getProductFormGroup(i).get('custom_product_name')?.invalid && getProductFormGroup(i).get('custom_product_name')?.touched}">
                  <div
                    *ngIf="getProductFormGroup(i).get('custom_product_name')?.invalid && getProductFormGroup(i).get('custom_product_name')?.touched"
                    class="text-red-500 text-xs mt-1">
                    É necessário especificar o produto
                  </div>
                </div>
              </div>

              <!-- Quantidade e Unidade -->
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Medida Total Aplicada:</label>
                <div class="flex gap-2">
                  <div style="flex: 7;">
                    <input id="product-{{i}}-total-quantity-v1" formControlName="total_quantity" type="text" inputmode="decimal"
                      placeholder="Ex: 4.5"
                      class="w-full px-3 py-2 border rounded-md shadow-sm sm:text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                      [disabled]="treatmentPlan.status === 'CLOSED'"
                      [ngClass]="{'border-gray-300': true, 'bg-gray-100 cursor-not-allowed': treatmentPlan.status === 'CLOSED'}"
                      (input)="onTotalQuantityInput($event, i)"
                      (blur)="onTotalQuantityBlur(i)">
                  </div>
                  <div style="flex: 3;">
                    <div class="relative group">
                      <button type="button" [id]="'dropdown-button-unit-' + i"
                        class="flex justify-between gap-2 items-center py-1.5 px-2 w-full rounded-md border text-gray-900 shadow-sm cursor-pointer focus:ring-2 focus:ring-indigo-500 sm:text-sm sm:leading-6"
                        [class.border-gray-300]="true"
                        [class.cursor-not-allowed]="treatmentPlan.status === 'CLOSED'"
                        [class.bg-gray-100]="treatmentPlan.status === 'CLOSED'"
                        [attr.aria-haspopup]="'listbox'"
                        [attr.aria-expanded]="openedUnitDropdowns.includes('unit-' + i)"
                        (click)="treatmentPlan.status !== 'CLOSED' ? openCloseUnitSelect(i) : null">
                        <div class="text-start">{{ getSelectedUnitLabel(i) }}</div>
                        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="currentColor" aria-hidden="true">
                          <path fill-rule="evenodd"
                            d="M6.293 9.293a1 1 0 011.414 0L10 11.586l2.293-2.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                            clip-rule="evenodd" />
                        </svg>
                      </button>
                      <div [id]="'dropdown-background-unit-' + i"
                        class="hidden bg-neutral-600 bg-opacity-70 fixed inset-0 z-10"
                        (click)="openCloseUnitSelect(i)">
                      </div>
                      <div [id]="'dropdown-menu-unit-' + i"
                        class="hidden z-20 absolute w-full mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 p-1 space-y-1">
                        <div class="block w-full max-h-52 overflow-auto p-1 cursor-pointer space-y-1">
                          <div *ngFor="let unit of unitsList"
                            class="unit-option flex items-center space-x-2 px-2 hover:bg-indigo-600 hover:text-white rounded-md">
                            <button type="button"
                              class="cursor-pointer w-full text-left py-2"
                              (click)="onUnitSelect(unit, i)">
                              {{ unit }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Região de Aplicação - Checkbox Multi-Select -->
            <div class="mb-4" [id]="'product-' + i + '-regions-section'">
              <div class="flex items-center gap-2" style="justify-content: flex-start !important;">
                <h3 class="font-medium text-lg" style="flex: none;">Regiões de Aplicação*</h3>
                <button *ngIf="treatmentPlan.status === 'ACTIVE'" type="button"
                  class="inline-flex items-center gap-1 px-3 py-1 text-sm border border-gray-300 rounded-md hover:bg-gray-100 text-gray-700"
                  style="flex: none;"
                  (click)="toggleRegionPanel(i)">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"></path>
                  </svg>
                  Adicionar
                </button>
              </div>

              <!-- Painel de seleção de regiões -->
              <div class="border border-gray-300 rounded-lg overflow-hidden mt-3">

                <!-- Botão para abrir/fechar painel -->
                <div class="p-3 border-b border-gray-200 bg-gray-50 cursor-pointer flex items-center justify-between"
                  (click)="toggleRegionPanel(i)"
                  [class.cursor-not-allowed]="treatmentPlan.status === 'CLOSED'">
                  <span class="text-sm text-gray-600">
                    {{ getSelectedRegionsList(i).length === 0 ? 'Nenhuma região selecionada. Clique em "Adicionar" para selecionar.' : getSelectedRegionsList(i).length + ' região(ões) selecionada(s)' }}
                  </span>
                  <svg class="w-5 h-5 text-gray-400 transition-transform flex-shrink-0" [class.rotate-180]="regionPanelOpen[i]"
                    fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                  </svg>
                </div>

                <!-- Painel expansível com busca e checkboxes -->
                <div *ngIf="regionPanelOpen[i]">
                  <!-- Chips das regiões selecionadas dentro do painel -->
                  <div *ngIf="getSelectedRegionsList(i).length > 0" class="p-3 border-b border-gray-200 bg-white">
                    <div class="flex flex-wrap gap-2">
                      <span *ngFor="let region of getSelectedRegionsList(i)"
                        class="inline-flex items-center gap-1 px-3 py-1 rounded-full text-sm bg-indigo-100 text-indigo-800">
                        {{ region.label }}
                        <button *ngIf="treatmentPlan.status === 'ACTIVE'" type="button"
                          (click)="removeRegionByIndex(i, region.index)"
                          class="ml-1 text-indigo-600 hover:text-red-500 focus:outline-none">
                          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                          </svg>
                        </button>
                      </span>
                    </div>
                  </div>

                  <!-- Campo de busca -->
                  <div class="p-3 border-b border-gray-200 bg-gray-50">
                    <div class="relative">
                      <svg class="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                      </svg>
                      <input
                        type="text"
                        placeholder="Filtrar regiões..."
                        [value]="regionSearchFilters[i] || ''"
                        (input)="onRegionFilterChange(i, $event)"
                        class="w-full pl-9 pr-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:border-indigo-600">
                    </div>
                  </div>

                  <!-- Checkboxes divididos em categorias -->
                  <div class="max-h-72 overflow-y-auto">

                    <!-- Categoria: Facial -->
                    <div *ngIf="getFilteredFacialRegions(i).length > 0" class="px-3 pt-3 pb-1">
                      <h4 class="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Facial</h4>
                      <div *ngFor="let region of getFilteredFacialRegions(i); let regionIndex = index" class="flex items-center gap-2 py-1.5">
                        <input type="checkbox"
                          [id]="'region-cb-facial-' + i + '-' + regionIndex"
                          [checked]="isRegionSelected(i, region)"
                          (change)="toggleRegionCheckbox(i, region)"
                          [disabled]="treatmentPlan.status === 'CLOSED'"
                          class="w-4 h-4 shrink-0 text-indigo-600 border-gray-300 rounded focus:ring-indigo-600" />
                        <label [for]="'region-cb-facial-' + i + '-' + regionIndex"
                          class="text-sm text-gray-700 cursor-pointer select-none">{{ region }}</label>
                      </div>
                    </div>

                    <!-- Separador -->
                    <div *ngIf="getFilteredFacialRegions(i).length > 0 && getFilteredCorporalRegions(i).length > 0"
                      class="border-t border-gray-200 mx-3"></div>

                    <!-- Categoria: Corporal -->
                    <div *ngIf="getFilteredCorporalRegions(i).length > 0" class="px-3 pt-3 pb-1">
                      <h4 class="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Corporal</h4>
                      <div *ngFor="let region of getFilteredCorporalRegions(i); let regionIndex = index" class="flex items-center gap-2 py-1.5">
                        <input type="checkbox"
                          [id]="'region-cb-corporal-' + i + '-' + regionIndex"
                          [checked]="isRegionSelected(i, region)"
                          (change)="toggleRegionCheckbox(i, region)"
                          [disabled]="treatmentPlan.status === 'CLOSED'"
                          class="w-4 h-4 shrink-0 text-indigo-600 border-gray-300 rounded focus:ring-indigo-600" />
                        <label [for]="'region-cb-corporal-' + i + '-' + regionIndex"
                          class="text-sm text-gray-700 cursor-pointer select-none">{{ region }}</label>
                      </div>
                    </div>

                    <!-- Nenhum resultado -->
                    <div *ngIf="getFilteredFacialRegions(i).length === 0 && getFilteredCorporalRegions(i).length === 0 && regionSearchFilters[i]"
                      class="text-sm text-gray-500 py-3 px-3">
                      Nenhuma região encontrada para "{{ regionSearchFilters[i] }}"
                    </div>
                  </div>

                  <!-- Adicionar região personalizada -->
                  <div *ngIf="treatmentPlan.status === 'ACTIVE'" class="p-3 border-t border-gray-200 bg-gray-50">
                    <label class="block text-sm font-medium text-gray-700 mb-1">Adicionar região personalizada</label>
                    <div class="flex gap-2">
                      <input type="text"
                        [value]="customRegionInput[i] || ''"
                        (input)="customRegionInput[i] = $any($event.target).value"
                        (keyup.enter)="addCustomRegion(i)"
                        placeholder="Ex: Região específica..."
                        class="flex-1 px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-600">
                      <button type="button" (click)="addCustomRegion(i)"
                        class="px-4 py-2 text-sm bg-indigo-600 text-white rounded-md hover:bg-indigo-700 focus:outline-none">
                        Adicionar
                      </button>
                    </div>

                    <!-- Lista de regiões personalizadas já adicionadas -->
                    <div *ngIf="getCustomRegionsList(i).length > 0" class="mt-3">
                      <p class="text-xs font-medium text-gray-600 mb-1.5">Regiões personalizadas adicionadas:</p>
                      <div class="flex flex-wrap gap-1.5">
                        <span *ngFor="let custom of getCustomRegionsList(i)"
                          class="inline-flex items-center gap-1.5 px-2 py-1 text-xs bg-indigo-100 text-indigo-800 rounded-md border border-indigo-200">
                          <span>{{ custom.label }}</span>
                          <button type="button"
                            (click)="removeRegionByIndex(i, custom.index)"
                            [attr.aria-label]="'Remover ' + custom.label"
                            class="text-indigo-600 hover:text-indigo-900 focus:outline-none">
                            <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3" viewBox="0 0 20 20" fill="currentColor">
                              <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                            </svg>
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Seção de Fotos -->
            <div class="mt-6" [id]="'product-' + i + '-photos-section'">
              <h3 class="font-medium text-lg mb-2">Fotos do Produto*</h3>
              <p class="text-sm text-gray-600 mb-1">Adicione as fotos do produto utilizado:</p>
              <ul class="text-sm text-gray-700 mb-2">
                <li>• Frasco</li>
                <li>• Caixa do Produto</li>
                <li>• Etiqueta</li>
              </ul>

              <div class="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-4">
                <!-- Frasco -->
                <div class="relative">
                  <h4 *ngIf="hasProductPhoto(getProductFormGroup(i).value, 'bottle') || treatmentPlan.status === 'ACTIVE'" class="text-sm font-medium mb-1">Frasco</h4>
                  
                  <!-- NOVO: Loading individual para foto do frasco -->
                  <div *ngIf="isProductPhotoUploading(getProductFormGroup(i).get('id')?.value || '', 'bottle')" 
                    class="bg-blue-50 border-2 border-blue-200 rounded-xl flex items-center justify-center h-36 md:h-48">
                    <div class="flex flex-col items-center text-blue-600">
                      <app-loading-spinner size="md" class="mb-2"></app-loading-spinner>
                      <span class="text-sm font-medium">Processando foto...</span>
                    </div>
                  </div>

                  <div *ngIf="hasProductPhoto(getProductFormGroup(i).value, 'bottle') && !isProductPhotoUploading(getProductFormGroup(i).get('id')?.value || '', 'bottle')"
                    class="relative bg-gray-50 border border-gray-200 rounded-xl shadow">
                    <div id="product-{{i}}-photo-bottle-existing"
                      class="h-36 md:h-48 flex items-center justify-center p-2 cursor-pointer"
                      (click)="showProductPhotoModal(getProductFormGroup(i).value, 'bottle'); updateImageRendering('bottle', getProductFormGroup(i).get('id')?.value || '')">
                      <img [src]="sanitizeUrl(getProductPhotoUrl(getProductFormGroup(i).value, 'bottle'))"
                        [attr.key]="getProductFormGroup(i).get('id')?.value" alt="Foto do Frasco"
                        class="max-w-full max-h-full object-contain p-2">
                    </div>
                    <div class="p-2 border-t">
                      <button *ngIf="treatmentPlan.status === 'ACTIVE'"
                        (click)="removeProductPhoto(getProductFormGroup(i).get('id')?.value || '', 'bottle')"
                        class="mt-1 px-2 py-1 text-xs bg-red-600 text-white rounded hover:bg-red-700 w-full flex items-center justify-center">
                        <fa-icon [icon]="faTrash" class="mr-1"></fa-icon>
                        Remover
                      </button>
                    </div>
                  </div>
                  <div *ngIf="!hasProductPhoto(getProductFormGroup(i).value, 'bottle') && !isProductPhotoUploading(getProductFormGroup(i).get('id')?.value || '', 'bottle') && treatmentPlan.status === 'ACTIVE'" id="product-{{i}}-photo-bottle-placeholder"
                    (click)="initPhotoCapture(getProductFormGroup(i).get('id')?.value || '', 'bottle')"
                    class="bg-gray-100 rounded-xl flex items-center justify-center cursor-pointer hover:bg-gray-200 h-36 md:h-48"
                    [class.cursor-not-allowed]="!getProductFormGroup(i).get('id')?.value"
                    [class.opacity-50]="!getProductFormGroup(i).get('id')?.value">
                    <span class="text-gray-400 flex flex-col items-center">
                      <i class="fas fa-plus text-xl md:text-2xl mb-1"></i>
                      <span class="text-xs md:text-sm">Adicionar</span>
                    </span>
                  </div>
                </div>

                <!-- Caixa -->
                <div class="relative">
                  <h4 *ngIf="hasProductPhoto(getProductFormGroup(i).value, 'box') || treatmentPlan.status === 'ACTIVE'" class="text-sm font-medium mb-1">Caixa</h4>
                  
                  <!-- NOVO: Loading individual para foto da caixa -->
                  <div *ngIf="isProductPhotoUploading(getProductFormGroup(i).get('id')?.value || '', 'box')" 
                    class="bg-blue-50 border-2 border-blue-200 rounded-xl flex items-center justify-center h-36 md:h-48">
                    <div class="flex flex-col items-center text-blue-600">
                      <app-loading-spinner size="md" class="mb-2"></app-loading-spinner>
                      <span class="text-sm font-medium">Processando foto...</span>
                    </div>
                  </div>

                  <div *ngIf="hasProductPhoto(getProductFormGroup(i).value, 'box') && !isProductPhotoUploading(getProductFormGroup(i).get('id')?.value || '', 'box')"
                    class="relative bg-gray-50 border border-gray-200 rounded-xl shadow">
                    <div id="product-{{i}}-photo-box-existing"
                      class="h-36 md:h-48 flex items-center justify-center p-2 cursor-pointer"
                      (click)="showProductPhotoModal(getProductFormGroup(i).value, 'box'); updateImageRendering('box', getProductFormGroup(i).get('id')?.value || '')">
                      <img [src]="sanitizeUrl(getProductPhotoUrl(getProductFormGroup(i).value, 'box'))"
                        [attr.key]="getProductFormGroup(i).get('id')?.value" alt="Foto da Caixa"
                        class="max-w-full max-h-full object-contain p-2">
                    </div>
                    <div class="p-2 border-t">
                      <button *ngIf="treatmentPlan.status === 'ACTIVE'"
                        (click)="removeProductPhoto(getProductFormGroup(i).get('id')?.value || '', 'box')"
                        class="mt-1 px-2 py-1 text-xs bg-red-600 text-white rounded hover:bg-red-700 w-full flex items-center justify-center">
                        <fa-icon [icon]="faTrash" class="mr-1"></fa-icon>
                        Remover
                      </button>
                    </div>
                  </div>
                  <div *ngIf="!hasProductPhoto(getProductFormGroup(i).value, 'box') && !isProductPhotoUploading(getProductFormGroup(i).get('id')?.value || '', 'box') && treatmentPlan.status === 'ACTIVE'" id="product-{{i}}-photo-box-placeholder"
                    (click)="initPhotoCapture(getProductFormGroup(i).get('id')?.value || '', 'box')"
                    class="bg-gray-100 rounded-xl flex items-center justify-center cursor-pointer hover:bg-gray-200 h-36 md:h-48"
                    [class.cursor-not-allowed]="!getProductFormGroup(i).get('id')?.value"
                    [class.opacity-50]="!getProductFormGroup(i).get('id')?.value">
                    <span class="text-gray-400 flex flex-col items-center">
                      <i class="fas fa-plus text-xl md:text-2xl mb-1"></i>
                      <span class="text-xs md:text-sm">Adicionar</span>
                    </span>
                  </div>
                </div>

                <!-- Etiqueta -->
                <div class="relative">
                  <h4 *ngIf="hasProductPhoto(getProductFormGroup(i).value, 'label') || treatmentPlan.status === 'ACTIVE'" class="text-sm font-medium mb-1">Etiqueta</h4>
                  
                  <!-- NOVO: Loading individual para foto da etiqueta -->
                  <div *ngIf="isProductPhotoUploading(getProductFormGroup(i).get('id')?.value || '', 'label')" 
                    class="bg-blue-50 border-2 border-blue-200 rounded-xl flex items-center justify-center h-36 md:h-48">
                    <div class="flex flex-col items-center text-blue-600">
                      <app-loading-spinner size="md" class="mb-2"></app-loading-spinner>
                      <span class="text-sm font-medium">Processando foto...</span>
                    </div>
                  </div>

                  <div *ngIf="hasProductPhoto(getProductFormGroup(i).value, 'label') && !isProductPhotoUploading(getProductFormGroup(i).get('id')?.value || '', 'label')"
                    class="relative bg-gray-50 border border-gray-200 rounded-xl shadow">
                    <div id="product-{{i}}-photo-label-existing"
                      class="h-36 md:h-48 flex items-center justify-center p-2 cursor-pointer"
                      (click)="showProductPhotoModal(getProductFormGroup(i).value, 'label'); updateImageRendering('label', getProductFormGroup(i).get('id')?.value || '')">
                      <img [src]="sanitizeUrl(getProductPhotoUrl(getProductFormGroup(i).value, 'label'))"
                        [attr.key]="getProductFormGroup(i).get('id')?.value" alt="Foto da Etiqueta"
                        class="max-w-full max-h-full object-contain p-2">
                    </div>
                    <div class="p-2 border-t">
                      <button *ngIf="treatmentPlan.status === 'ACTIVE'"
                        (click)="removeProductPhoto(getProductFormGroup(i).get('id')?.value || '', 'label')"
                        class="mt-1 px-2 py-1 text-xs bg-red-600 text-white rounded hover:bg-red-700 w-full flex items-center justify-center">
                        <fa-icon [icon]="faTrash" class="mr-1"></fa-icon>
                        Remover
                      </button>
                    </div>
                  </div>
                  <div *ngIf="!hasProductPhoto(getProductFormGroup(i).value, 'label') && !isProductPhotoUploading(getProductFormGroup(i).get('id')?.value || '', 'label') && treatmentPlan.status === 'ACTIVE'" id="product-{{i}}-photo-label-placeholder"
                    (click)="initPhotoCapture(getProductFormGroup(i).get('id')?.value || '', 'label')"
                    class="bg-gray-100 rounded-xl flex items-center justify-center cursor-pointer hover:bg-gray-200 h-36 md:h-48"
                    [class.cursor-not-allowed]="!getProductFormGroup(i).get('id')?.value"
                    [class.opacity-50]="!getProductFormGroup(i).get('id')?.value">
                    <span class="text-gray-400 flex flex-col items-center">
                      <i class="fas fa-plus text-xl md:text-2xl mb-1"></i>
                      <span class="text-xs md:text-sm">Adicionar</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Botão para adicionar novo produto -->
          <div *ngIf="treatmentPlan.status === 'ACTIVE'" class="flex justify-center">
            <button (click)="addNewProduct()"
              class="bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2 px-4 rounded-md flex items-center text-sm md:text-base">
              <span
                class="bg-white text-indigo-600 rounded-full w-5 h-5 md:w-6 md:h-6 flex items-center justify-center mr-2">
                <span class="font-bold">+</span>
              </span>
              Adicionar Novo Produto
            </button>
          </div>

          <!-- Texto informando que não tem produtos -->
          <div *ngIf="productsArray.controls.length === 0 && treatmentPlan.status === 'CLOSED'" class="flex justify-center items-center text-black ">
            <p>Nenhum produto adicionado.</p>
          </div>
        </div>
      </div>

      <!-- Aba de Fotos -->
      <div *ngIf="activeTab === 'photos'" class="bg-white rounded-lg shadow-md p-4 md:p-6">
        <div class="flex justify-between items-center mb-4 md:mb-6">
          <h2 class="text-lg font-semibold">Fotos do Tratamento</h2>
        </div>

        <!-- Seção de Fotos de Marcação -->
        <div class="mb-6 md:mb-8 border border-gray-200 rounded-lg p-4 md:p-6 bg-gray-50">
          <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4">
            <h3 id="marking-photos" class="text-lg md:text-xl font-semibold mb-2 sm:mb-0">Fotos de Marcação</h3>
          </div>

          <p class="text-gray-600 mb-4">Insira fotos de marcação da paciente.</p>

          <div *ngIf="treatmentPlan?.status === 'ACTIVE'" class="flex flex-wrap gap-2 mb-6">
            <button (click)="selectedPhotoType = 'MARKING'; initTreatmentPhotoCapture()"
              class="px-3 py-2 text-sm md:px-4 md:py-2 md:text-base bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center">
              <fa-icon [icon]="faAdd" class="mr-2"></fa-icon>
              Adicionar Foto
            </button>
          </div>

          <div *ngIf="loading" class="my-4 text-center text-gray-500">
            <app-loading-spinner size="md" class="mx-auto mb-2"></app-loading-spinner>
            <p>Carregando fotos...</p>
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            <div *ngFor="let photo of getMarkingPhotos()"
              class="relative bg-gray-50 rounded-xl shadow border border-gray-200">

              <div *ngIf="isTreatmentPhotoLoading(photo.id!)"
                class="absolute inset-0 bg-white bg-opacity-80 flex flex-col items-center justify-center rounded-xl z-10">
                <app-loading-spinner size="md" class="mb-2"></app-loading-spinner>
                <span class="text-sm font-medium text-indigo-700">
                  {{ deletingPhotoIds.has(photo.id!) ? 'Removendo...' : processingBackendPhotoIds.has(photo.id!) ? 'Processando imagem...' : 'Fazendo upload...' }}
                </span>
              </div>

              <div class="w-full h-40 sm:h-48 flex items-center justify-center p-2 cursor-pointer"
                (click)="showPhotoModal(photo)">
                <img [src]="sanitizeUrl(photo.photo_url)" alt="Foto de Marcação"
                  class="max-w-full max-h-full object-contain rounded-xl">
              </div>
              <div class="p-3 border-t">
                <p class="text-sm font-medium truncate">{{ photo.description }}</p>
                <button *ngIf="treatmentPlan?.status === 'ACTIVE'" (click)="removePhoto(photo.id || '')"
                  class="mt-1 px-2 py-1 text-xs bg-red-600 text-white rounded hover:bg-red-700 w-full flex items-center justify-center">
                  <fa-icon [icon]="faTrash" class="mr-1"></fa-icon>
                  Remover
                </button>
              </div>
            </div>

            <div *ngIf="getMarkingPhotos().length === 0 && !loading"
              class="col-span-full p-4 text-center text-gray-500 bg-gray-100 rounded-lg">
              <p>Ainda não há fotos de marcação. Use o botão "Adicionar Foto" acima para incluir imagens.</p>
            </div>
          </div>
        </div>

        <!-- Seção de Fotos Pré-Tratamento -->
        <div class="mb-6 md:mb-8 border border-gray-200 rounded-lg p-4 md:p-6 bg-gray-50">
          <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4">
            <h3 id="pre-treatment-photos" class="text-lg md:text-xl font-semibold mb-2 sm:mb-0">Fotos do Pré-Tratamento
              (ANTES)</h3>
          </div>

          <p class="text-gray-600 mb-4">Insira fotos da paciente antes do tratamento.</p>

          <div *ngIf="treatmentPlan?.status === 'ACTIVE'" class="flex flex-wrap gap-2 mb-6">
            <button (click)="selectedPhotoType = 'PRE'; initTreatmentPhotoCapture()"
              class="px-3 py-2 text-sm md:px-4 md:py-2 md:text-base bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center">
              <fa-icon [icon]="faAdd" class="mr-2"></fa-icon>
              Adicionar Foto
            </button>
          </div>

          <div *ngIf="loading" class="my-4 text-center text-gray-500">
            <app-loading-spinner size="md" class="mx-auto mb-2"></app-loading-spinner>
            <p>Carregando fotos...</p>
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            <div *ngFor="let photo of getPreTreatmentPhotos()"
              class="relative bg-gray-50 rounded-xl shadow border border-gray-200">

              <div *ngIf="isTreatmentPhotoLoading(photo.id!)"
                class="absolute inset-0 bg-white bg-opacity-80 flex flex-col items-center justify-center rounded-xl z-10">
                <app-loading-spinner size="md" class="mb-2"></app-loading-spinner>
                <span class="text-sm font-medium text-indigo-700">
                  {{ deletingPhotoIds.has(photo.id!) ? 'Removendo...' : processingBackendPhotoIds.has(photo.id!) ? 'Processando imagem...' : 'Fazendo upload...' }}
                </span>
              </div>

              <div class="w-full h-40 sm:h-48 flex items-center justify-center p-2 cursor-pointer"
                (click)="showPhotoModal(photo)">
                <img [src]="sanitizeUrl(photo.photo_url)" alt="Foto Pré-Procedimento"
                  class="max-w-full max-h-full object-contain rounded-xl">
              </div>
              <div class="p-3 border-t">
                <p class="text-sm font-medium truncate">{{ photo.description }}</p>
                <button *ngIf="treatmentPlan?.status === 'ACTIVE'" (click)="removePhoto(photo.id || '')"
                  class="mt-1 px-2 py-1 text-xs bg-red-600 text-white rounded hover:bg-red-700 w-full flex items-center justify-center">
                  <fa-icon [icon]="faTrash" class="mr-1"></fa-icon>
                  Remover
                </button>
              </div>
            </div>

            <div *ngIf="getPreTreatmentPhotos().length === 0 && !loading"
              class="col-span-full p-4 text-center text-gray-500 bg-gray-100 rounded-lg">
              <p>Ainda não há fotos de pré-tratamento. Use o botão "Adicionar Foto" acima para incluir imagens.</p>
            </div>
          </div>
        </div>

        <!-- Seção de Fotos Pós-Imediato -->
        <div class="mb-6 md:mb-8 border border-gray-200 rounded-lg p-4 md:p-6 bg-gray-50">
          <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4">
            <h3 id="immediate-post-photos" class="text-lg md:text-xl font-semibold mb-2 sm:mb-0">Fotos do Pós-Imediato</h3>
          </div>

          <p class="text-gray-600 mb-4">Insira fotos da paciente no pós-imediato do tratamento.</p>

          <div *ngIf="treatmentPlan?.status === 'ACTIVE'" class="flex flex-wrap gap-2 mb-6">
            <button (click)="selectedPhotoType = 'IMMEDIATE_POST'; initTreatmentPhotoCapture()"
              class="px-3 py-2 text-sm md:px-4 md:py-2 md:text-base bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center">
              <fa-icon [icon]="faAdd" class="mr-2"></fa-icon>
              Adicionar Foto
            </button>
          </div>

          <div *ngIf="loading" class="my-4 text-center text-gray-500">
            <app-loading-spinner size="md" class="mx-auto mb-2"></app-loading-spinner>
            <p>Carregando fotos...</p>
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            <div *ngFor="let photo of getImmediatePostPhotos()"
              class="relative bg-gray-50 rounded-xl shadow border border-gray-200">

              <div *ngIf="isTreatmentPhotoLoading(photo.id!)"
                class="absolute inset-0 bg-white bg-opacity-80 flex flex-col items-center justify-center rounded-xl z-10">
                <app-loading-spinner size="md" class="mb-2"></app-loading-spinner>
                <span class="text-sm font-medium text-indigo-700">
                  {{ deletingPhotoIds.has(photo.id!) ? 'Removendo...' : processingBackendPhotoIds.has(photo.id!) ? 'Processando imagem...' : 'Fazendo upload...' }}
                </span>
              </div>

              <div class="w-full h-40 sm:h-48 flex items-center justify-center p-2 cursor-pointer"
                (click)="showPhotoModal(photo)">
                <img [src]="sanitizeUrl(photo.photo_url)" alt="Foto Pós-Imediato"
                  class="max-w-full max-h-full object-contain rounded-xl">
              </div>
              <div class="p-3 border-t">
                <p class="text-sm font-medium truncate">{{ photo.description }}</p>
                <button *ngIf="treatmentPlan?.status === 'ACTIVE'" (click)="removePhoto(photo.id || '')"
                  class="mt-1 px-2 py-1 text-xs bg-red-600 text-white rounded hover:bg-red-700 w-full flex items-center justify-center">
                  <fa-icon [icon]="faTrash" class="mr-1"></fa-icon>
                  Remover
                </button>
              </div>
            </div>

            <div *ngIf="getImmediatePostPhotos().length === 0 && !loading"
              class="col-span-full p-4 text-center text-gray-500 bg-gray-100 rounded-lg">
              <p>Ainda não há fotos de pós-imediato. Use o botão "Adicionar Foto" acima para incluir imagens.</p>
            </div>
          </div>
        </div>

        <!-- Seção de Fotos Pós-Tratamento -->
        <div class="mb-6 md:mb-8 border border-gray-200 rounded-lg p-4 md:p-6 bg-gray-50">
          <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4">
            <h3 id="post-treatment-photos" class="text-lg md:text-xl font-semibold mb-2 sm:mb-0">Fotos do Pós-Tratamento
              (DEPOIS)</h3>
          </div>

          <p class="text-gray-600 mb-4">Insira fotos da paciente após o tratamento.</p>

          <div *ngIf="treatmentPlan?.status === 'ACTIVE'" class="flex flex-wrap gap-2 mb-6">
            <button (click)="selectedPhotoType = 'POST'; initTreatmentPhotoCapture()"
              class="px-3 py-2 text-sm md:px-4 md:py-2 md:text-base bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center">
              <fa-icon [icon]="faAdd" class="mr-2"></fa-icon>
              Adicionar Foto
            </button>
          </div>

          <div *ngIf="loading" class="my-4 text-center text-gray-500">
            <app-loading-spinner size="md" class="mx-auto mb-2"></app-loading-spinner>
            <p>Carregando fotos...</p>
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            <div *ngFor="let photo of getPostTreatmentPhotos()"
              class="relative bg-gray-50 rounded-xl shadow border border-gray-200">

              <div *ngIf="isTreatmentPhotoLoading(photo.id!)"
                class="absolute inset-0 bg-white bg-opacity-80 flex flex-col items-center justify-center rounded-xl z-10">
                <app-loading-spinner size="md" class="mb-2"></app-loading-spinner>
                <span class="text-sm font-medium text-indigo-700">
                  {{ deletingPhotoIds.has(photo.id!) ? 'Removendo...' : processingBackendPhotoIds.has(photo.id!) ? 'Processando imagem...' : 'Fazendo upload...' }}
                </span>
              </div>

              <div class="w-full h-40 sm:h-48 flex items-center justify-center p-2 cursor-pointer"
                (click)="showPhotoModal(photo)">
                <img [src]="sanitizeUrl(photo.photo_url)" alt="Foto Pós-Procedimento"
                  class="max-w-full max-h-full object-contain rounded-xl">
              </div>
              <div class="p-3 border-t">
                <p class="text-sm font-medium truncate">{{ photo.description }}</p>
                <button *ngIf="treatmentPlan?.status === 'ACTIVE'" (click)="removePhoto(photo.id || '')"
                  class="mt-1 px-2 py-1 text-xs bg-red-600 text-white rounded hover:bg-red-700 w-full flex items-center justify-center">
                  <fa-icon [icon]="faTrash" class="mr-1"></fa-icon>
                  Remover
                </button>
              </div>
            </div>

            <div *ngIf="getPostTreatmentPhotos().length === 0 && !loading"
              class="col-span-full p-4 text-center text-gray-500 bg-gray-100 rounded-lg">
              <p>Ainda não há fotos de pós-tratamento. Use o botão "Adicionar Foto" acima para incluir imagens.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Modal para visualização de foto em tamanho maior -->
<div *ngIf="selectedViewPhoto"
  class="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-2 md:p-0"
  (click)="selectedViewPhoto = null">
  <div class="relative max-w-4xl w-full mx-2 md:mx-4" (click)="$event.stopPropagation()">
    <div class="bg-white rounded-lg overflow-hidden">
      <!-- Cabeçalho com título e botão X alinhados horizontalmente -->
      <div class="flex justify-between items-center p-3 md:p-4 border-b">
        <div class="flex flex-col md:flex-row md:items-center gap-2 md:gap-3 flex-1 mr-3">
          <h3 class="text-base md:text-lg font-medium truncate">{{ selectedViewPhoto.description }}</h3>
          <span class="px-2 py-1 md:px-3 md:py-1 rounded-full text-xs self-start md:self-auto" [ngClass]="{'bg-blue-100 text-blue-800': selectedViewPhoto.type === 'PRE', 
                    'bg-green-100 text-green-800': selectedViewPhoto.type === 'POST'}">
            {{ selectedViewPhoto.type === 'PRE' ? 'Pré-Tratamento' : 'Pós-Tratamento' }}
          </span>
        </div>
        
        <!-- Botão de fechar -->
        <button (click)="selectedViewPhoto = null"
          class="bg-red-600 hover:bg-red-700 rounded-full w-7 h-7 md:w-8 md:h-8 flex items-center justify-center shadow-md flex-shrink-0">
          <span class="text-white font-bold text-lg md:text-xl">×</span>
        </button>
      </div>

      <div class="p-2 md:p-4 flex flex-col">
        <!-- Controles de Zoom -->
        <div class="flex justify-center gap-2 mb-3">
          <button (click)="zoomOut('treatment')" class="bg-indigo-600 hover:bg-indigo-700 text-white rounded-md px-3 py-2 flex items-center justify-center shadow text-sm font-medium">
            <span>−</span>
          </button>
          <button (click)="resetZoom('treatment')" class="bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-md px-3 py-2 text-xs font-medium flex items-center justify-center shadow">
            Redefinir
          </button>
          <button (click)="zoomIn('treatment')" class="bg-indigo-600 hover:bg-indigo-700 text-white rounded-md px-3 py-2 flex items-center justify-center shadow text-sm font-medium">
            <span>+</span>
          </button>
        </div>

        <!-- Área de Zoom/Pan -->
        <div class="overflow-hidden w-full bg-black/5 rounded flex justify-center items-center select-none" style="height: 55vh; max-height: 70vh;"
             (wheel)="onViewWheel($event, 'treatment')"
             (mousedown)="onViewPanStart($event, 'treatment')"
             (mousemove)="onViewPanMove($event, 'treatment')"
             (mouseup)="onViewPanEnd($event, 'treatment')"
             (mouseleave)="onViewPanEnd($event, 'treatment')"
             (touchstart)="onViewPanStart($event, 'treatment')"
             (touchmove)="onViewPanMove($event, 'treatment')"
             (touchend)="onViewPanEnd($event, 'treatment')">
          <img [src]="selectedViewPhoto.photo_url"
               [style.transform]="'translate(' + treatmentTransX + 'px,' + treatmentTransY + 'px) scale(' + treatmentZoom + ')'"
               class="max-h-full max-w-full object-contain cursor-grab select-none"
               draggable="false">
        </div>
      </div>

      <div class="p-3 md:p-4 border-t">
        <p class="text-xs md:text-sm text-gray-500">
          {{ selectedViewPhoto.description }}
        </p>
      </div>
    </div>
  </div>
</div>

<!-- Modal para visualização de foto de produto em tamanho maior -->
<div *ngIf="selectedProductViewPhoto"
  class="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-2 md:p-0"
  (click)="selectedProductViewPhoto = null">
  <div class="relative max-w-4xl w-full mx-2 md:mx-4" (click)="$event.stopPropagation()">
    <div class="bg-white rounded-lg overflow-hidden">
      <!-- Cabeçalho com título e botão X alinhados horizontalmente -->
      <div class="flex justify-between items-center p-3 md:p-4 border-b">
        <h3 class="text-base md:text-lg font-medium truncate flex-1 mr-3">{{ getProductPhotoTypeLabel() }}</h3>
        
        <!-- Botão de fechar -->
        <button (click)="selectedProductViewPhoto = null"
          class="bg-red-600 hover:bg-red-700 rounded-full w-7 h-7 md:w-8 md:h-8 flex items-center justify-center shadow-md flex-shrink-0">
          <span class="text-white font-bold text-lg md:text-xl">×</span>
        </button>
      </div>

      <div class="p-2 md:p-4 flex flex-col">
        <!-- Controles de Zoom -->
        <div class="flex justify-center gap-2 mb-3">
          <button (click)="zoomOut('product')" class="bg-indigo-600 hover:bg-indigo-700 text-white rounded-md px-3 py-2 flex items-center justify-center shadow text-sm font-medium">
            <span>−</span>
          </button>
          <button (click)="resetZoom('product')" class="bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-md px-3 py-2 text-xs font-medium flex items-center justify-center shadow">
            Redefinir
          </button>
          <button (click)="zoomIn('product')" class="bg-indigo-600 hover:bg-indigo-700 text-white rounded-md px-3 py-2 flex items-center justify-center shadow text-sm font-medium">
            <span>+</span>
          </button>
        </div>

        <!-- Área de Zoom/Pan -->
        <div class="overflow-hidden w-full bg-black/5 rounded flex justify-center items-center select-none" style="height: 55vh; max-height: 70vh;"
             (wheel)="onViewWheel($event, 'product')"
             (mousedown)="onViewPanStart($event, 'product')"
             (mousemove)="onViewPanMove($event, 'product')"
             (mouseup)="onViewPanEnd($event, 'product')"
             (mouseleave)="onViewPanEnd($event, 'product')"
             (touchstart)="onViewPanStart($event, 'product')"
             (touchmove)="onViewPanMove($event, 'product')"
             (touchend)="onViewPanEnd($event, 'product')">
          <img [src]="sanitizeUrl(selectedProductViewPhoto)"
               [style.transform]="'translate(' + productTransX + 'px,' + productTransY + 'px) scale(' + productZoom + ')'"
               class="max-h-full max-w-full object-contain cursor-grab select-none"
               draggable="false">
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal de confirmação para encerrar tratamento -->
<div *ngIf="showCloseTreatmentModal"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
  <div class="bg-white rounded-lg p-4 md:p-6 max-w-md w-full">
    <div class="flex justify-between items-start mb-4">
      <h3 class="text-base md:text-lg font-medium">Encerrar Tratamento</h3>
      <button (click)="showCloseTreatmentModal = false" class="text-gray-500 hover:text-gray-700">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="mb-4 md:mb-6">
      <p class="text-sm md:text-base text-gray-700 mb-4">Declaro que finalizei todos os procedimentos previstos no plano de tratamento do paciente, conforme as condutas técnicas e éticas aplicáveis.</p>

      <p class="text-sm md:text-base text-gray-700 mb-4">Ao clicar em 'Encerrar Tratamento', estou ciente de que este plano será arquivado de forma definitiva no prontuário, não podendo mais ser editado ou alterado.</p>

      <div class="flex items-center mb-4">
        <input type="checkbox" [(ngModel)]="confirmCloseTreatment" id="confirm-close-treatment"
          class="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded">
        <label for="confirm-close-treatment" class="ml-2 block text-sm text-gray-700">
          Confirmo que todas as informações clínicas foram devidamente registradas.
        </label>
      </div>
    </div>

    <div class="flex justify-end gap-2">
      <button (click)="showCloseTreatmentModal = false"
        class="bg-gray-200 hover:bg-gray-300 text-black font-medium py-2 px-3 md:px-4 rounded-md flex items-center text-sm md:text-base">
        <i class="fas fa-times mr-2"></i>
        Cancelar
      </button>

      <button (click)="confirmCloseTreatmentPlan()" [disabled]="!confirmCloseTreatment"
        [ngClass]="{'bg-indigo-600 hover:bg-indigo-700': confirmCloseTreatment, 'bg-indigo-300 cursor-not-allowed': !confirmCloseTreatment}"
        class="text-white font-medium py-2 px-3 md:px-4 rounded-md flex items-center text-sm md:text-base">
        <i class="fas fa-check mr-2"></i>
        Encerrar Tratamento
      </button>
    </div>
  </div>
</div>

<!-- Modal de progresso de encerramento (fases) -->
<div *ngIf="showPublishingModal"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-4">
  <div class="bg-white rounded-2xl shadow-2xl p-6 md:p-8 max-w-md w-full">

    <!-- Cabeçalho com ícone -->
    <div class="flex flex-col items-center text-center mb-6">
      <div *ngIf="publishingPhase !== 'completed'" class="mb-4">
        <img src="assets/img/Loading.svg" alt="Carregando..." class="w-20 h-20" />
      </div>
      <div *ngIf="publishingPhase === 'completed'"
        class="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
        <svg class="w-8 h-8 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
        </svg>
      </div>

      <h2 class="text-lg md:text-xl font-semibold text-neutral-900">
        <ng-container *ngIf="publishingPhase !== 'completed'">Finalizando plano de tratamento</ng-container>
        <ng-container *ngIf="publishingPhase === 'completed'">Tudo pronto!</ng-container>
      </h2>
      <p *ngIf="publishingPhase !== 'completed'" class="text-sm text-neutral-600 mt-1">
        Por favor, aguarde enquanto finalizamos o processo.
      </p>
      <p *ngIf="publishingPhase === 'completed'" class="text-sm text-neutral-600 mt-1">
        Plano encerrado e enviado para o paciente com sucesso.
      </p>
    </div>

    <!-- Lista de fases (visível enquanto está processando) -->
    <div *ngIf="publishingPhase !== 'completed'" class="space-y-3 mb-2">
      <!-- Fase 1: Salvando informações -->
      <div class="flex items-center gap-3">
        <div class="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-colors"
          [ngClass]="{
            'bg-westetics-purple-100': isPublishingPhaseActive('saving'),
            'bg-westetics-purple-600': isPublishingPhaseComplete('saving'),
            'bg-neutral-100': !isPublishingPhaseActive('saving') && !isPublishingPhaseComplete('saving')
          }">
          <img *ngIf="isPublishingPhaseActive('saving')" src="assets/img/Loading.svg" alt="Carregando..." class="w-6 h-6" />
          <svg *ngIf="isPublishingPhaseComplete('saving')" class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="3">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"></path>
          </svg>
        </div>
        <span class="text-sm md:text-base transition-colors"
          [ngClass]="{
            'text-neutral-900 font-medium': isPublishingPhaseActive('saving'),
            'text-neutral-600': isPublishingPhaseComplete('saving'),
            'text-neutral-400': !isPublishingPhaseActive('saving') && !isPublishingPhaseComplete('saving')
          }">
          Salvando informações
        </span>
      </div>

      <!-- Fase 2: Encerrando o Plano -->
      <div class="flex items-center gap-3">
        <div class="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-colors"
          [ngClass]="{
            'bg-westetics-purple-100': isPublishingPhaseActive('closing'),
            'bg-westetics-purple-600': isPublishingPhaseComplete('closing'),
            'bg-neutral-100': !isPublishingPhaseActive('closing') && !isPublishingPhaseComplete('closing')
          }">
          <img *ngIf="isPublishingPhaseActive('closing')" src="assets/img/Loading.svg" alt="Carregando..." class="w-6 h-6" />
          <svg *ngIf="isPublishingPhaseComplete('closing')" class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="3">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"></path>
          </svg>
        </div>
        <span class="text-sm md:text-base transition-colors"
          [ngClass]="{
            'text-neutral-900 font-medium': isPublishingPhaseActive('closing'),
            'text-neutral-600': isPublishingPhaseComplete('closing'),
            'text-neutral-400': !isPublishingPhaseActive('closing') && !isPublishingPhaseComplete('closing')
          }">
          Encerrando o Plano
        </span>
      </div>

      <!-- Fase 3: Gerando e enviando documento para o Paciente -->
      <div class="flex items-center gap-3">
        <div class="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-colors"
          [ngClass]="{
            'bg-westetics-purple-100': isPublishingPhaseActive('generating'),
            'bg-westetics-purple-600': isPublishingPhaseComplete('generating'),
            'bg-neutral-100': !isPublishingPhaseActive('generating') && !isPublishingPhaseComplete('generating')
          }">
          <img *ngIf="isPublishingPhaseActive('generating')" src="assets/img/Loading.svg" alt="Carregando..." class="w-6 h-6" />
          <svg *ngIf="isPublishingPhaseComplete('generating')" class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="3">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"></path>
          </svg>
        </div>
        <span class="text-sm md:text-base transition-colors"
          [ngClass]="{
            'text-neutral-900 font-medium': isPublishingPhaseActive('generating'),
            'text-neutral-600': isPublishingPhaseComplete('generating'),
            'text-neutral-400': !isPublishingPhaseActive('generating') && !isPublishingPhaseComplete('generating')
          }">
          Gerando e enviando documento para o Paciente
        </span>
      </div>
    </div>

    <!-- Botão Entendi (aparece só quando concluído) -->
    <button *ngIf="publishingPhase === 'completed'" (click)="closePublishingModal()"
      class="w-full py-3 px-4 mt-2 rounded-lg font-medium text-white transition-all duration-200 bg-westetics-purple-600 hover:bg-westetics-purple-800">
      Entendi
    </button>
  </div>
</div>

<!-- Modal de confirmação para remover item -->
<div *ngIf="showRemoveConfirmModal"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
  <div class="bg-white rounded-lg p-4 md:p-6 max-w-md w-full">
    <div class="flex justify-between items-start mb-4">
      <h3 class="text-base md:text-lg font-medium">Confirmar Remoção</h3>
      <button (click)="cancelRemoveConfirm()" [disabled]="removeConfirmLoading" class="text-gray-500 hover:text-gray-700" [class.opacity-50]="removeConfirmLoading">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="mb-4 md:mb-6">
      <p class="text-sm md:text-base text-gray-700 mb-4">
        <ng-container *ngIf="removeConfirmType === 'product'">Tem certeza que deseja remover o produto: <span class="font-medium">{{ removeConfirmName }}</span>?</ng-container>
        <ng-container *ngIf="removeConfirmType !== 'product'">Tem certeza que deseja remover a foto?</ng-container>
      </p>
      <p class="text-xs md:text-sm text-red-600">Esta ação não pode ser desfeita.</p>
    </div>

    <div class="flex justify-end gap-2">
      <button (click)="cancelRemoveConfirm()" [disabled]="removeConfirmLoading"
        class="bg-gray-200 hover:bg-gray-300 text-black font-medium py-2 px-3 md:px-4 rounded-md flex items-center text-sm md:text-base"
        [class.opacity-50]="removeConfirmLoading" [class.cursor-not-allowed]="removeConfirmLoading">
        <i class="fas fa-times mr-2"></i>
        Cancelar
      </button>

      <button (click)="removeConfirmType === 'product' ? confirmRemoveProduct() : confirmRemovePhoto()"
        [disabled]="removeConfirmLoading"
        class="bg-red-500 hover:bg-red-600 text-white font-medium py-2 px-3 md:px-4 rounded-md flex items-center justify-center gap-2 text-sm md:text-base min-w-[120px]"
        [class.opacity-75]="removeConfirmLoading" [class.cursor-not-allowed]="removeConfirmLoading">
        <app-loading-spinner *ngIf="removeConfirmLoading" size="sm"></app-loading-spinner>
        <i *ngIf="!removeConfirmLoading" class="fas fa-trash-alt text-white mr-2"></i>
        {{ removeConfirmLoading ? 'Removendo...' : 'Remover' }}
      </button>
    </div>
  </div>
</div>

<!-- Modal de QR Code -->
<div *ngIf="showQrCode" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2">
  <div class="bg-white rounded-lg p-3 max-w-lg w-full max-h-screen overflow-y-auto relative">
    <!-- Botão de fechar global para todos os popups relacionados a imagens -->
    <button (click)="closeQrCode()"
      class="absolute top-2 right-2 bg-red-600 rounded-full w-6 h-6 flex items-center justify-center shadow-md z-50">
      <span class="text-white font-bold text-sm">X</span>
    </button>

    <div class="flex justify-between items-center mb-3">
      <h3 class="text-sm md:text-base font-medium pr-8">{{ getQrCodeTitle() }}</h3>
    </div>

    <div class="flex flex-col items-center">
      <div class="w-full text-left">
        <p class="text-sm font-medium mb-2 md:mb-3">Siga os passos abaixo:</p>

        <ol class="list-decimal pl-4 mb-3 md:mb-4 space-y-1 text-xs">
          <li>Leia o QRCode abaixo com a câmera do seu dispositivo móvel OU use o link direto</li>
          <li>Mantenha este popup aberto e tire as fotos do produto.</li>
        </ol>
      </div>

      <!-- Seção do QR Code responsiva -->
      <div id="qrCode" class="mb-3 bg-white p-3 md:p-6 rounded-lg shadow-sm border flex flex-col items-center w-full">
        <!-- Spinner enquanto o backend gera o short-link.
             Sem isso, o <qrcode> renderizava com qrCodeUrl vazia/antiga e
             flashava brevemente até o backend retornar (~300-800ms). -->
        <div *ngIf="qrCodeLoading" class="flex flex-col items-center justify-center w-64 h-64 md:w-80 md:h-80 mb-3 md:mb-4">
          <app-loading-spinner size="lg"></app-loading-spinner>
          <p class="text-xs text-gray-500 mt-3">Gerando QR Code...</p>
        </div>

        <!-- QR Code só renderiza depois que qrCodeUrl está populado.
             allowEmptyString=true silencia o warning do angularx-qrcode
             durante change detection (qrdata pode ser '' por 1 frame antes
             do *ngIf destruir o componente). O *ngIf continua impedindo
             render real de QR vazio. -->
        <qrcode *ngIf="!qrCodeLoading && qrCodeUrl"
          [qrdata]="qrCodeUrl"
          [allowEmptyString]="true"
          [width]="isMobile ? 280 : 350"
          [errorCorrectionLevel]="'L'"
          [colorDark]="'#000000'"
          [colorLight]="'#FFFFFF'"
          [margin]="4"
          class="mb-3 md:mb-4 w-64 h-64 md:w-80 md:h-80">
        </qrcode>

        <p *ngIf="!qrCodeLoading" class="text-xs text-orange-500 mb-2 text-center">QRCode expirará em até 1h</p>
        
        <!-- Mensagem de erro se houver -->
        <div *ngIf="errorMessage" class="w-full mb-2 p-2 bg-red-50 border border-red-200 rounded-md">
          <p class="text-xs text-red-600 text-center">
            <i class="fas fa-exclamation-triangle mr-1"></i>
            {{ errorMessage }}
          </p>
        </div>
        
        <!-- Link direto para casos onde o QR Code falha -->
        <div class="w-full border-t pt-2 mt-2">
          <p class="text-xs font-medium text-gray-700 mb-2 text-center">Link direto:</p>
          
          <!-- Botões de ação para o link -->
          <div class="flex flex-col space-y-1">
            <button 
              (click)="copyQrCodeLink()"
              class="w-full bg-blue-600 hover:bg-blue-700 text-white text-xs py-2 md:py-1.5 px-2 rounded-md flex items-center justify-center transition-colors">
              <i class="fas fa-copy mr-1"></i>
              Copiar Link
            </button>
            
            <button 
              (click)="openQrCodeLink()"
              class="w-full bg-green-600 hover:bg-green-700 text-black text-xs py-2 md:py-1.5 px-2 rounded-md flex items-center justify-center transition-colors">
              <i class="fas fa-external-link-alt mr-1"></i>
              Abrir Link
            </button>
          </div>
          
          <!-- Instruções adicionais -->
          <div class="mt-2 p-2 bg-blue-50 border border-blue-200 rounded-md">
            <p class="text-xs text-blue-700 text-center">
              <i class="fas fa-info-circle mr-1"></i>
              Se o QR Code não funcionar, copie o link e envie por WhatsApp ou abra em uma nova aba
            </p>
          </div>
        </div>
      </div>

      <div class="w-full text-left mt-2 mb-3">
        <p class="text-xs font-medium mb-1">3. Quando finalizar, confirme no botão abaixo.</p>
      </div>

      <div class="w-full border-t pt-3 mt-1">
        <div class="flex items-center mb-3">
          <input type="checkbox" id="confirm-photos-finished-checkbox" [(ngModel)]="qrCodePhotosFinishedCheckbox"
            class="w-4 h-4 md:w-3 md:h-3 text-indigo-600 bg-gray-100 border-gray-300 rounded focus:ring-indigo-500">
          <label for="confirm-photos-finished-checkbox" class="ml-2 text-xs md:text-sm font-medium text-gray-900">
            Confirmo que terminei de tirar todas as fotos
          </label>
        </div>

        <button (click)="refreshPhotos()" [disabled]="!qrCodePhotosFinishedCheckbox"
          class="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-3 md:py-2 px-3 rounded-md flex items-center justify-center text-sm md:text-xs"
          [ngClass]="{'opacity-50 cursor-not-allowed': !qrCodePhotosFinishedCheckbox, 'hover:bg-indigo-700': qrCodePhotosFinishedCheckbox}">
          <i class="fas fa-check mr-1"></i>
          Tirei todas as fotos
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal de opções de upload para produtos e tratamentos -->
<div *ngIf="showUploadOptions" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
  <div class="bg-white rounded-lg p-4 md:p-6 max-w-sm w-full relative">
    <!-- Loading overlay para conversão HEIC -->
    <div *ngIf="processingHeic || processingProductHeic" class="absolute inset-0 bg-white bg-opacity-90 flex flex-col items-center justify-center rounded-lg z-10">
      <app-loading-spinner size="lg" class="mb-4"></app-loading-spinner>
      <p class="text-sm text-gray-600">Processando imagem...</p>
    </div>

    <div class="flex justify-between items-start mb-4 gap-3">
      <h3 class="text-base md:text-lg font-medium flex-1 min-w-0">
        <span *ngIf="currentUploadType === 'product'">Adicionar Foto(s) do {{ getPhotoTypeLabel() }}</span>
        <span *ngIf="currentUploadType === 'treatment'">Adicionar Foto(s) do Tratamento</span>
      </h3>
      <button type="button" (click)="showUploadOptions = false; clearPhotoPreview()"
        class="text-gray-500 hover:text-gray-700 flex-shrink-0 leading-none p-1 -mt-1 -mr-1 text-2xl" aria-label="Fechar">
        &times;
      </button>
    </div>

    <!-- Informação sobre disponibilidade de câmera -->
    <div *ngIf="!isMobileDevice() && !hasCamera" class="mb-4 p-3 bg-yellow-50 border-l-4 border-yellow-400">
      <div class="flex">
        <div class="flex-shrink-0">
          <i class="fas fa-exclamation-triangle text-yellow-400"></i>
        </div>
        <div class="ml-3">
          <p class="text-sm text-yellow-700">
            Câmera não detectada neste dispositivo. Use a opção "Galeria" para selecionar uma imagem.
          </p>
        </div>
      </div>
    </div>

    <div class="flex flex-col space-y-3 md:space-y-4 mb-2 md:mb-4">
      <!-- Botão de câmera - sempre mostrar, mas com estilos diferentes baseado na disponibilidade -->
      <button (click)="selectCaptureOption('camera')"
        [disabled]="processingHeic || processingProductHeic || !hasCamera"
        [ngClass]="{
          'bg-gray-50 hover:bg-gray-100 border-gray-200': (isMobileDevice() || hasCamera) && !processingHeic && !processingProductHeic,
          'bg-gray-200 border-gray-300 opacity-60': (!isMobileDevice() && !hasCamera) || processingHeic || processingProductHeic
        }"
        class="flex items-center justify-between p-3 md:p-4 rounded-lg border disabled:cursor-not-allowed">
        <div class="flex items-center">
          <i class="fas fa-camera text-lg md:text-xl mr-3"
             [ngClass]="{
               'text-indigo-600': isMobileDevice() || hasCamera,
               'text-gray-400': !isMobileDevice() && !hasCamera
             }"></i>
          <div class="text-left">
            <span class="text-sm md:text-base block">Tirar Foto</span>
            <span *ngIf="!isMobileDevice() && !hasCamera" class="text-xs text-gray-500">Câmera não disponível</span>
          </div>
        </div>
        <i class="fas fa-chevron-right text-gray-400"></i>
      </button>

      <!-- Botão de galeria (múltipla para tratamento, única para produto) -->
      <button (click)="selectCaptureOption('gallery')"
        [disabled]="processingHeic || processingProductHeic"
        [ngClass]="{
          'bg-gray-50 hover:bg-gray-100 border-gray-200': !processingHeic && !processingProductHeic,
          'bg-gray-200 border-gray-300 opacity-60': processingHeic || processingProductHeic
        }"
        class="flex items-center justify-between p-3 md:p-4 rounded-lg border disabled:cursor-not-allowed">
        <div class="flex items-center">
          <i class="fas fa-images text-lg md:text-xl text-indigo-600 mr-3"></i>
          <div class="text-left">
            <span class="text-sm md:text-base block">Galeria</span>
            <span class="text-xs text-gray-500" *ngIf="currentUploadType === 'treatment'">Selecionar uma ou várias imagens</span>
            <span class="text-xs text-gray-500" *ngIf="currentUploadType === 'product'">Selecionar uma imagem</span>
          </div>
        </div>
        <i class="fas fa-chevron-right text-gray-400"></i>
      </button>

      <button
        (click)="selectCaptureOption('qrcode')"
        [disabled]="processingHeic || processingProductHeic"
        [ngClass]="{
          'bg-gray-50 hover:bg-gray-100 border-gray-200': !processingHeic && !processingProductHeic,
          'bg-gray-200 border-gray-300 opacity-60': processingHeic || processingProductHeic
        }"
        class="flex items-center justify-between p-3 md:p-4 rounded-lg border disabled:cursor-not-allowed">
        <div class="flex items-center">
          <i class="fas fa-qrcode text-lg md:text-xl text-indigo-600 mr-3"></i>
          <div class="text-left">
            <span class="text-sm md:text-base block">Código QR</span>
            <span class="text-xs text-gray-500">Usar dispositivo móvel</span>
          </div>
        </div>
        <i class="fas fa-chevron-right text-gray-400"></i>
      </button>
    </div>
  </div>
</div>

<!-- Input de arquivo oculto para múltiplas fotos de tratamento -->
<input id="treatment-photo-input-multiple" type="file" multiple accept="image/*,.heic,.HEIC,.heif,.HEIF" (change)="onMultiplePhotosSelected($event)"
  style="display: none;">

<!-- Input de arquivo oculto para foto única de produto -->
<input id="product-photo-input-single" type="file" accept="image/*,.heic,.HEIC,.heif,.HEIF" (change)="onSinglePhotoSelected($event)"
  style="display: none;">

<!-- Adicionar estilos para ocultar a barra de rolagem -->
<style>
  .hide-scrollbar::-webkit-scrollbar {
    display: none;
  }

  .hide-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
</style>

<!-- Modal de câmera para captura em tempo real -->
<div *ngIf="isCameraActive" class="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50">
  <div class="bg-white rounded-lg p-4 max-w-lg w-full mx-4 relative">
    
    <!-- Cabeçalho do modal de câmera -->
    <div class="flex justify-between items-center mb-4">
      <h3 class="text-lg font-medium text-gray-900">
        Capturar Foto
        <span *ngIf="currentUploadType === 'product'" class="text-sm text-gray-600 block">
          {{ getPhotoTypeLabel() }}
        </span>
        <span *ngIf="currentUploadType === 'treatment'" class="text-sm text-gray-600 block">
          Foto {{ selectedPhotoType === 'PRE' ? 'Pré-Tratamento' : 'Pós-Tratamento' }}
        </span>
      </h3>
      
      <!-- Botão de fechar -->
      <button (click)="stopCamera(); isCameraActive = false" 
              class="bg-red-600 text-white px-3 py-1 rounded-md hover:bg-red-700 transition-colors">
        <span class="text-sm font-medium">✕ Fechar</span>
      </button>
    </div>

    <!-- Área do vídeo da câmera -->
    <div class="relative bg-black rounded-lg overflow-hidden mb-4">
      <video id="camera-video" 
             autoplay 
             playsinline 
             muted
             class="w-full h-64 object-cover">
      </video>
      
      <!-- Overlay de loading enquanto câmera carrega -->
      <div *ngIf="!cameraStream" class="absolute inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75">
        <div class="text-white text-center">
          <app-loading-spinner size="md" class="mx-auto mb-2"></app-loading-spinner>
          <p class="text-sm">Inicializando câmera...</p>
        </div>
      </div>
    </div>

    <!-- Botões de ação -->
    <div class="flex justify-center space-x-4">
      <button (click)="capturePhoto()" 
              [disabled]="!cameraStream"
              class="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors">
        📷 Capturar Foto
      </button>
      
      <button (click)="stopCamera(); isCameraActive = false; showUploadOptions = true" 
              class="bg-gray-600 text-white px-6 py-2 rounded-md hover:bg-gray-700 transition-colors">
        Cancelar
      </button>
    </div>
    
    <!-- Informações da câmera (apenas para debug) -->
    <div *ngIf="cameraStream" class="mt-2 text-xs text-gray-500 text-center">
      Câmera ativa • Clique em "Capturar Foto" quando estiver pronto
    </div>
  </div>
</div>

<!-- Modal de progresso para upload múltiplo -->
<div *ngIf="showMultipleUploadProgress" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
  <div class="bg-white rounded-lg p-4 md:p-6 max-w-md w-full relative">
    <div class="text-center">
      <h3 class="text-base md:text-lg font-medium mb-4">
        Fazendo Upload das Fotos
      </h3>
      
      <!-- Progresso geral -->
      <div class="mb-4">
        <div class="flex justify-between text-sm text-gray-600 mb-2">
          <span>Foto {{ currentFileIndex }} de {{ totalFilesToUpload }}</span>
          <span>{{ multipleUploadProgress.toFixed(0) }}%</span>
        </div>
        <div class="w-full bg-gray-200 rounded-full h-2.5">
          <div 
            class="bg-blue-600 h-2.5 rounded-full transition-all duration-300" 
            [style.width.%]="multipleUploadProgress">
          </div>
        </div>
      </div>
      
      <!-- Nome do arquivo atual -->
      <div class="mb-4 p-3 bg-gray-50 rounded-lg">
        <p class="text-sm text-gray-600 mb-1">Processando:</p>
        <p class="text-sm font-medium text-gray-800 truncate">{{ currentUploadFileName }}</p>
      </div>
      
      <!-- Ícone de loading -->
      <div class="flex justify-center">
        <app-loading-spinner size="md"></app-loading-spinner>
      </div>
    </div>
  </div>
</div>